import type { ButtonHTMLAttributes } from "react";
import { cn } from "../tokens.js";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "default" | "ghost" | "danger";
}

export function Button({ variant = "default", className, type = "button", ...rest }: ButtonProps) {
  return <button type={type} className={cn("ui-btn", variant !== "default" && `ui-btn--${variant}`, className)} {...rest} />;
}
